export default __webpack_public_path__ + "static/media/cryptokenT.87bffcab.png";